import React from "react";
import "../css/ItemDescription.css";
import DOMPurify from "dompurify";


const formatContent = (text) => {
  const parts = text.split(/(<link>[^<]+<\/link>|\*\*[^*]+\*\*)/g);

  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    } else if (part.startsWith("<link>") && part.endsWith("</link>")) {
      const url = part.slice(6, -7).trim();
      return (
        <a key={i} href={url} target="_blank" rel="noopener noreferrer">
          Link
        </a>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

const isLikelyHtml = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

const ItemDescription = ({ description }) => {
  if (!description) return null;
  
   if (isLikelyHtml(description)) {
    const safe = DOMPurify.sanitize(description, {
      USE_PROFILES: { html: true },
      ADD_ATTR: ["target", "rel"],
    });

    return (
      <div
        className="item-description"
        dangerouslySetInnerHTML={{ __html: safe }}
      />
    );
  }


  const lines = description.split("\n");
  const elements = [];
  let currentList = [];

  lines.forEach((line, index) => {
    const trimmed = line.trim();
   if (/^\*\s+/.test(trimmed)) {
      currentList.push(
        <li key={`li-${index}`}>{formatContent(trimmed.replace(/^\*\s+/, ""))}</li>
      );
    } else {
      if (currentList.length > 0) {
        elements.push(<ul key={`ul-${index}`}>{currentList}</ul>);
        currentList = [];
      }
      if (trimmed !== "") {
        elements.push(<p key={`p-${index}`}>{formatContent(trimmed)}</p>);
      }
    }
  });

  if (currentList.length > 0) {
    elements.push(<ul key="ul-last">{currentList}</ul>);
  }

  return <div className="item-description">{elements}</div>;
};

export default ItemDescription;
